@if (selectionOptions.length > 1) {
  <mat-button-toggle-group
    [(ngModel)]="selectionType"
    class="mb-12 mt-24"
    id="button-group-action-package"
    [disabled]="!tripBookingPackagesStepService.hasParticipants"
    [matTooltip]="tripBookingPackagesStepService.hasParticipants ? null : 'Inserire almeno un partecipante'"
    >
    @for (item of selectionOptions; track item) {
      <mat-button-toggle [value]="item.value">
        <mat-icon>{{item.icon}}</mat-icon>
        <span class="ml-4 text-semibold">{{item.label}}</span>
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
}

@if (selectionOptions.length == 1) {
  <h2>{{selectionOptions[0].label}}</h2>
  @if (!tripBookingPackagesStepService.hasParticipants) {
    <p style="color: #8f8f8f">Inserire almeno un partecipante</p>
  }
}

@if (selectionType == 'trip_packages') {
  <package-trip-selection></package-trip-selection>
}
@if (selectionType == 'products') {
  <product-selection></product-selection>
}
@if (selectionType == 'trenitalia') {
  <app-trenitalia-dialog (complete)="selectionType = null"></app-trenitalia-dialog>
}
@if (selectionType == 'trenitalia-carnet') {
  <app-trenitalia-carnet (complete)="selectionType = null"></app-trenitalia-carnet>
}
@if (selectionType == 'milano_card') {
  <milano-card-selection></milano-card-selection>
}
